<div class="section-header">
  <div class="section-title-container">
    <h2 class="section-title">{{ title }}</h2>
    <div class="help-tooltip-container" *ngIf="helpText || resolvedHelpUrl">
      <span class="help-tooltip-icon">
        <i class="fa fa-question-circle"></i>
      </span>
      <div class="help-tooltip-content">
        <div *ngIf="helpText" class="help-description">{{ helpText }}</div>
        <a
          *ngIf="!isLoadingHelp && resolvedHelpUrl"
          class="help-link"
          [href]="resolvedHelpUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fa fa-external-link-alt"></i> Learn more
        </a>
      </div>
    </div>
  </div>
  <div class="section-actions">
    <ng-content></ng-content>
  </div>
</div>
<div class="section-divider"></div>
